import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import React from 'react';
import {
  getDataSharingData,
  getDataSharingColumns,
  getDataSharingIsLoading,
} from '../redux/selectors/DataSharingSelectors';
import { DataSharingContainerStyle } from '../component/DataSharingContainer.styles';
import TableDefinitions from '../../../../common/TableDefinitions';
import ListTable from '../../../../common/list-table/components/ListTable';

function DataSharingContainer(props) {
  const {
    data,
    columns,
    loading,
  } = props;
  return (
    <DataSharingContainerStyle>
      <ListTable
        listId={TableDefinitions.DATA_SHARING_VIEW.id}
        columns={columns}
        loading={loading}
        data={data}
      />
    </DataSharingContainerStyle>
  );
}
const mapStateToProps = (state) => ({
  data: getDataSharingData(state),
  loading: getDataSharingIsLoading(state),
  columns: getDataSharingColumns(state),
});

DataSharingContainer.propTypes = {
  data: PropTypes.arrayOf(PropTypes.any),
  loading: PropTypes.bool,
  columns: PropTypes.arrayOf(PropTypes.any),
};

export default connect(mapStateToProps)(DataSharingContainer);
